import { Component, OnInit, Input } from "@angular/core";

import { CTAButtonLayout } from "../cta-button-layout";
import { CtaButtonLayoutCallPackContext } from "./cta-button-layout-call-pack.models";

@Component({
    selector: "dodo-cta-button-layout-call-pack",
    templateUrl: "./cta-button-layout-call-pack.component.html",
    styleUrls: ["./cta-button-layout-call-pack.component.scss"],
    standalone: false
})
export class CtaButtonLayoutCallPackComponent
	extends CTAButtonLayout
	implements OnInit {
	@Input() id: number;
	@Input() title: string;
	@Input() iconImage: string;
	@Input() descriptions: string[];

	@Input() marketing: {
		text: string;
		textDecoration: string;
	};

	@Input() set context(ctx: CtaButtonLayoutCallPackContext) {
		if (ctx) {
			this.__updatePropertyFromContext(ctx);
		}
	}

	@Input() set discount(descriptions: string[]) {
		if (descriptions) {
			this.descriptions = descriptions;
		}
	}

	set layoutContext(ctx: CtaButtonLayoutCallPackContext) {
		if (ctx) {
			this.__updatePropertyFromContext(ctx);
		}
	}

	private __updatePropertyFromContext(ctx: CtaButtonLayoutCallPackContext) {
		this.id = this.id || ctx.id;
		this.title = this.title || ctx.title;
		this.iconImage = this.iconImage || ctx.iconImage;
		this.descriptions = this.descriptions || ctx.descriptions;
		this.marketing = this.marketing || ctx.marketing;
	}

	constructor() {
		super();
	}

	ngOnInit() {}
}
